<nav class="navbar navbar-expand-lg navbar-dark header-bg p-3">
  <img class="logo_ ml-4" src="../../assets/images/green_logo_1.svg">
  
  <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav"
    aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse justify-content-end" id="navbarNav">
    <ul class="navbar-nav">
      <li class="nav-item ">
        <a class="nav-link borderBottom" (click)="changeNavHome()">HOME</a>
      </li>
      <li class="nav-item ">
        <a class="nav-link borderBottom" (click)="changeNavScholars()">SCHOLARSHIPS</a>
      </li>
      <li class="nav-item ">
        <a class="nav-link borderBottom" [ngClass]="{'actives': selected == 'plans'}" (click)="changeNav()">PLANS</a>
      </li>
      <li class="nav-item ">
        <a class="nav-link borderBottom" (click)="changeNavAbout()">ABOUT US</a>
      </li>
      <!-- <li class="nav-item position-relative no-hover">
        <div class="custm_btn"><a style="color: white;" (click)="changeNav1('login')" target="_self"> Login</a><a>
          <span style="color: white;padding: 0px 2px;"> |</span>
          </a><a style="color: white;" (click)="changeNav1('signup')" target="_self"> Register </a></div>
      </li> -->
    </ul>
  </div>
  <div class="collapse navbar-collapse justify-content-center" id="navbarNav">
    <ul class="navbar-nav">
      
      <li class="nav-item  no-hover">
        <div class="custm_btn"><a style="color: white;" (click)="changeNav1('login')" target="_self"> Login</a><a>
          <span style="color: white;padding: 0px 2px;"> |</span>
          </a><a style="color: white;" (click)="changeNav1('signup')" target="_self"> Register </a></div>
      </li>
    </ul>
  </div>
</nav>



